<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

  <div [hidden]="isLoading" class="col-md-10 offset-md-1">
    <ziro-breadcrumbs [tooltip]="'tkey;shared.about_card'">
      @if (isHosted && !isLoading) {
        <ziro-breadcrumb-card-item [aboutCardId]="87"></ziro-breadcrumb-card-item>
      }
      @if (!isHosted) {
        <ziro-breadcrumb-card-item>
          <div>
            <h5 class="mb-3 customize-ui-about-h5">{{ 'tkey;admin.ui.customize_login_page_ui.header' | translate }}</h5>
            <div [innerHTML]="'tkey;admin.ui.about_card.login_page_ui.zpc' | escapeHtml" class="mb-4"></div>

            <h5 class="mb-3 customize-ui-about-h5">
              {{ 'tkey;admin.ui.customize_support_contact.header' | translate }}
            </h5>
            <div [innerHTML]="'tkey;admin.ui.about_card.support_contact.zpc' | escapeHtml"></div>
          </div>
        </ziro-breadcrumb-card-item>
      }
    </ziro-breadcrumbs>

    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false" [title]="'tkey;admin.ui.header'">
      <div class="d-flex mb-3">
        <div class="flex-fill">
          <ziro-file-upload [fieldId]="'logo'"></ziro-file-upload>
        </div>
        <div class="d-flex input-action-buttons">
          <ziro-button
            class="preview-btn logo-preview-btn"
            [dataAutomation]="'customize-ui-logo-preview-btn'"
            (clicked)="onPreviewClick(customizeUiPhotoTypes.LOGO)"
            [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
            [buttonSize]="buttonSizes.NORMAL"
            [icon]="ziroIcons.PREVIEW"
            [isDisabled]="!uiProperties || !uiProperties.logo"
          ></ziro-button>
          <ziro-button
            class="delete-btn"
            [dataAutomation]="'customize-ui-logo-delete-btn'"
            (clicked)="onDeleteClick(customizeUiPhotoTypes.LOGO)"
            [buttonStyle]="buttonStyles.OUTLINE_DANGER"
            [buttonSize]="buttonSizes.NORMAL"
            [icon]="ziroIcons.DELETE_SMALL"
            [isDisabled]="!uiProperties || !uiProperties.logo"
          ></ziro-button>
        </div>
      </div>
      <div class="d-flex mb-3">
        <div class="flex-fill">
          <ziro-file-upload [fieldId]="'backgroundImage'"></ziro-file-upload>
        </div>
        <div class="d-flex input-action-buttons">
          <ziro-button
            class="preview-btn"
            [dataAutomation]="'customize-ui-background-image-preview-btn'"
            (clicked)="onPreviewClick(customizeUiPhotoTypes.BACKGROUND_IMAGE)"
            [buttonStyle]="buttonStyles.OUTLINE_DEFAULT"
            [buttonSize]="buttonSizes.NORMAL"
            [icon]="ziroIcons.PREVIEW"
            [isDisabled]="!uiProperties || !uiProperties.backgroundImage"
          ></ziro-button>
          <ziro-button
            class="delete-btn"
            [dataAutomation]="'customize-ui-background-image-delete-btn'"
            (clicked)="onDeleteClick(customizeUiPhotoTypes.BACKGROUND_IMAGE)"
            [buttonStyle]="buttonStyles.OUTLINE_DANGER"
            [buttonSize]="buttonSizes.NORMAL"
            [icon]="ziroIcons.DELETE_SMALL"
            [isDisabled]="!uiProperties || !uiProperties.backgroundImage"
          ></ziro-button>
        </div>
      </div>

      <div class="d-flex mb-4">
        <div class="flex-fill">
          <ziro-color-picker [fieldId]="'backgroundColor'"></ziro-color-picker>
        </div>
        <div class="spacer"></div>
      </div>
    </ziro-collapsible-section-card>

    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;admin.ui.login_page_ui.preview.header'"
      [class]="'login-page-preview'"
    >
      <div class="card-body" [style]="previewBackgroundStyles">
        <button
          type="button"
          class="preview-maximize-btn"
          (click)="onFullPreviewClick()"
          data-automation="login-page-preview-maximize-btn"
        >
          <i [ngClass]="ziroIcons.MAXIMIZE"></i>
        </button>
        <div class="d-flex justify-content-center py-5">
          <div class="login-container-form border-rad-all-2">
            <div>
              <img
                class="company-logo-image"
                [src]="previewLogo"
                alt="Company Logo"
                data-automation="login-page-preview-logo"
              />
            </div>
            <div class="top-buffer mb-0">
              <button
                class="btn btn-border btn-primary btn-lg w-100"
                type="button"
                data-automation="login-page-preview-button"
              >
                <i [ngClass]="ziroIcons.LOCK" class="me-2"></i>
                {{ loginButtonLabel }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ziro-collapsible-section-card>

    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;admin.ui.support.header'"
    >
      <ziro-code-area [fieldId]="'supportTextHtml'"></ziro-code-area>
      <div class="row mb-4">
        <div class="ziro-forms-label col-form-label col-lg-3 text-lg-end">
          <label>{{ 'tkey;admin.ui.support.preview.label' | translate }}</label>
        </div>
        <div class="col-lg-9 support-text-preview" data-automation="support-text-html-preview">
          <div class="form-control font-light" [innerHTML]="supportTextHtmlPreview | escapeHtml"></div>
        </div>
      </div>
    </ziro-collapsible-section-card>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
